import React from 'react';
import { YoutubePlayer, YoutubePlayerProps } from '../YouTubePlayer/YouTubePlayer';
import { useStackVideoPlayerContext } from '../hooks/useStackVideoPlayer';
import AspectRatio from '@jbhi-fi/lanyard-ui/components/AspectRatio';
import { styles } from './StackYoutubePlayer.css';

export type StackYoutubeVariant = 'default' | 'genericPage';

export type StackYoutubePlayerProps = YoutubePlayerProps & {
  variant?: StackYoutubeVariant;
};
// StackYoutubePlayer required to support multiple video players on a single view and to control playback via external controls
export const StackYoutubePlayer = (props: StackYoutubePlayerProps) => {
  const { addPlayer } = useStackVideoPlayerContext();

  const handleAddPlayer: StackYoutubePlayerProps['onPlayerLoaded'] = player => {
    addPlayer?.(player);
    props.onPlayerLoaded?.(player);
  };

  return (
    <div className={styles.stackYoutubePlayer({ variant: props.variant || 'default' })}>
      <AspectRatio ratio={16 / 9}>
        <YoutubePlayer {...props} onPlayerLoaded={handleAddPlayer} isOrientationFixed={true} />
      </AspectRatio>
    </div>
  );
};
